import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables'
import {EntryHomepage} from './EntryHomepage'

export class EntryWeb extends EntryHomepage {
    constructor() {
        super()
        void this.initialize()
    }

    async initialize() {
        await super.initialize()
    }
}

if(!UIUtilsEjsVariables.isUserOnDiscord) new EntryWeb()
